<template>
    <div class="feedback-list">
        <van-nav-bar
            title="反馈列表"
            @click-left="onClickLeft"
        >
            <template #right>
                <!-- 下拉选择 -->
                <van-dropdown-menu>
                    <van-dropdown-item
                        style="right:0"
                        v-model="stationId"
                        :options="stationList"
                        @change="search"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <van-search v-model="keywords" placeholder="请输入供应单编号/规格/物料名称" @change="search"></van-search>
        <div class="warpper van-pull-refresh" :class="{ 'no_data': isActive }">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                :error.sync="error"
                :error-text="errorText"
                @load="onLoad"
            >
                <div
                    class="materialPlan-item"
                    v-for="(item) in materialPlanList"
                    :key="item.poid"
                >
                    <div class="corner-marker feedback-wfk" v-if="item.supplier_state===1">
                        <p class="text">
                            未反馈
                        </p>
                    </div>
                    <div class="corner-marker feedback-yfk" v-else>
                        <p class="text">
                            已反馈
                        </p>
                    </div>
                    <ul @click="btnClick('FeedbackSubmit',item)">
                        <li class="tit">
                            <span class="pre-icon materialPlan07"></span>
                            <span class="info">供应单编号:{{ item.no }}</span>
                        </li>
                        <li class="name-length">
                            <span class="pre-icon materialPlan01"></span>
                            <span class="info">供应商名称:{{ item.supplier_name }}</span>
                        </li>
                        <li>
                            <van-row>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan01"></span>
                                    <span class="info">物料名称:{{ item.goods_name }}</span>
                                </van-col>
                                <van-col span="12">
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">规格:{{ item.spec_name }}</span>
                                </van-col>
                            </van-row>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan05"></span>
                            <span class="info info-bar">计划量:{{ item.supply_count }}吨</span>
                        </li>
                        <li class="name-length">
                            <span class="pre-icon materialPlan04"></span>
                            <span class="info">供应场站:{{ item.station_name }}</span>
                        </li>
                        <li>
                            <span class="pre-icon materialPlan06"></span>
                            <span class="info">供应时间:{{ item.supply_date }}</span>
                        </li>
                    </ul>
                    <div class="btn-wrapper" v-if="item.supplier_state === 1">
                        <van-row type="flex" justify="space-around">
                            <van-col span="8">
                                <span class="btn btn_order_taking" @click="btnClick('FeedbackSubmit',item)">
                                    反馈
                                </span>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-list>
        </div>
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>
<script>
export default {
    name: 'feedback-list',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'feedback-list');
        }
        next();
    },
    data() {
        return {
            // 搜索关键字
            keywords: '',
            // 当前选择的场站id
            stationId: '',
            // 场站列表
            stationList: [{ value: '', text: '全部' }],
            materialPlanList: [],
            loading: true,
            finished: false,
            page: {
                pageindex: 1,
                pagesize: 20,
            },
            isActive: false,
            error: false,
            errorText: '',
            finishedText: '没有更多了',
        };
    },
    methods: {
        async init() {
            this.getStationList();
            this.getList();
        },
        // 搜索
        search() {
            this.pageindex = 1;
            this.finished = false;
            this.loading = true;
            this.materialPlanList = [];
            this.getList();
        },
        handleBack() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'home' });
        },
        btnClick(name, item) {
            this.$router.isBack = 2;
            this.$router.push({ name: name, query: { row: JSON.stringify(item) } });
        },
        // 数据分页加载
        onLoad() {
            setTimeout(() => {
                this.page.pageindex += 1;
                this.getList();
            }, 200);
        },
        // 通过用户获取相关订单列表（分页）
        getList() {
            this.$axios
                .get('/interfaceApi/procurement/daily/supply/get_supply_response_page?pageindex='
                 + this.page.pageindex + '&pagesize=' + this.page.pagesize
                    + '&station_id=' + this.stationId + '&search=' + this.keywords)
                .then(res => {
                    this.loading = false;
                    this.materialPlanList.push(...res.rows);
                    if (this.materialPlanList.length >= res.total) {
                        this.finishedText = '没有更多了';
                        this.finished = true;
                    }
                    if (this.materialPlanList.length === 0 ) {
                        this.finishedText = '';
                        this.isActive = true;
                        this.finished = true;
                    } else {
                        this.isActive = false;
                    }
                })
                .catch(error => {
                    this.error = true;
                    this.loading = false;
                    this.errorText = error.ErrorCode.Message;
                });
        },
        // 拉取场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        value: id,
                        text: stationNames[index],
                    };
                });
                this.stationList.push(...stationList );
                this.stationId = this.stationList[0].value;
            }
        },
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.back();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="stylus" scoped>
.feedback-list
    height calc(100% - 44rpx)
    position relative
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .warpper
        height calc(100% - 87rpx)
        background #F0F0F0
        overflow-y auto
        overflow-x hidden
        padding 0 12rpx 12rpx 12rpx
        &.no_data
            background url(./../../assets/images/common/no_data.png) left center no-repeat
            background-size contain
        .materialPlan-item
            width 100%
            background #ffffff
            margin-top 15rpx
            position relative
            overflow hidden
            padding 16rpx
            color #666666
            font-size 14rpx
            li
                overflow hidden
                margin-bottom 10rpx
                &.name-length
                    display flex
                    .info
                        flex 1
                .pre-icon
                    width 16rpx
                    height 16rpx
                    float left
                    background-size 100% 100%
                    background-repeat no-repeat
                    display inline-block
                    margin 2rpx 10rpx 0 0
                    &.materialPlan01
                        background-image url(./../../assets/images/icons/icon_gy_3.png)
                    &.materialPlan02
                        background-image url(./../../assets/images/icons/icon_34.png)
                    &.materialPlan03
                        background-image url(./../../assets/images/icons/icon_gy_5.png)
                    &.materialPlan04
                        background-image url(./../../assets/images/icons/icon_gy_2.png)
                    &.materialPlan05
                        background-image url(./../../assets/images/icons/icon_30.png)
                    &.materialPlan06
                        background-image url(./../../assets/images/icons/icon_gy_7.png)
                    &.materialPlan07
                         background-image url(./../../assets/images/icons/icon_gy_1.png)
                .info
                    float left
                .info-bar
                    float left
                    width 125rpx
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                &.tit
                    font-size 16rpx
                    color #061F3E
            .feedback-wfk
                background #FF6600
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .feedback-yfk
                background #979EA7
                .text
                    position absolute
                    bottom 0
                    padding 0
                    margin 0
                    color #fff
                    width 100%
            .corner-marker
                width 60rpx
                height 60rpx
                position absolute
                right -30rpx
                top -30rpx
                transform rotate(45deg)
                -webkit-transform rotate(45deg)
                -moz-transform rotate(45deg)
                font-size 10rpx
                text-align center
            .btn-wrapper
                border-top 2rpx solid #F0F0F0
                padding-top 15rpx
                .btn
                    width 100rpx
                    height 30rpx
                    line-height 30rpx
                    text-align center
                    display block
                    border-radius 4rpx
                    &.btn_order_taking
                        background #5494F3
                        color #ffffff
                    &.btn_refuse
                        border 2rpx solid rgba(85,136,241,1)
                        color #5494F3
                        line-height 26rpx

    >>> .van-nav-bar__right
        height 40rpx
        overflow hidden
    >>> .van-dropdown-menu
        margin-top 1px;
        .van-dropdown-menu__bar
            box-shadow none;
</style>
<style>
    .materialPlan-box .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }

</style>
